<mat-card style="margin: 10px;" class="mat-elevation-z1">
  <app-search-universal-basic (Search)="searchReports($event)" (Reload)="reload($event)"></app-search-universal-basic>
</mat-card>

<mat-card style="margin: 10px;">
  <ejs-tab #TabGrid cssClass="underline-customize">
    <div class="e-tab-header" >
      <div ><span style="color:dimgray">Search Results</span></div>
      <div><span style="color:dimgray">+ Create Report</span></div>
      <div style="display:none;"></div>
    </div>
    <div class="e-content">
      <div>
        <ng-template #detailRow let-report>
          <div style="overflow: hidden;display: flex;">
            <div>
              <button mat-button (click)="DownloadPDF(report.ReportID)"><mat-icon>picture_as_pdf</mat-icon>View/Download PDF</button>

              <button mat-button (click)="EmailReport(report)" [disabled]="!isReportAssociationsCompleted(report) || report.Incidents?.length<2" *ngIf="report.Lab?.toLowerCase() == user.CurrentDept?.toLowerCase()" ><mat-icon>send</mat-icon>Email PDF</button>
              <button mat-button (click)="EmailLogs(report)" *ngIf="report.Lab?.toLowerCase() == user.CurrentDept?.toLowerCase()" ><mat-icon>all_inbox</mat-icon>Email Sent Logs</button>
              <button mat-button (click)="ViewLinkAnalysisReport(report)" [disabled]="report.ReportStatus!='COMPLETE' || report.Incidents?.length<2" ><mat-icon>account_tree</mat-icon>Link Analysis</button>
              <button mat-button (click)="ViewTimeLineReport(report)" [disabled]="report.ReportStatus!='COMPLETE' || report.Incidents?.length<2" ><mat-icon>timeline</mat-icon>Time Line Analysis</button>
              <button mat-button (click)="importToNewReport(report)"><mat-icon>edit</mat-icon>Import to New Report</button>
              <button mat-button (click)="editReport(report)" *ngIf="report.Lab?.toLowerCase() == user.CurrentDept.toLowerCase()"><mat-icon>add</mat-icon>Edit Report</button>

              <div style="font-size:10pt; text-align:center; color:red; margin:10px;" *ngIf="!isReportAssociationsCompleted(report)">
                <span style="border-radius: 10px; border: 2px solid red;padding: 10px;">"EMAIL PDF" is disabled for missing evidence association for incident(s).</span>
              </div>

              <div style="border: 2px dashed grey; padding: 10px; margin: 10px;">
                <app-report-preview [ReportInfo]="report" [labsn]="report.Lab" [incidents]="report.Incidents"></app-report-preview>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template #NIBINHitTemplate let-report>
        <span>
          <span *ngIf="report.NIBINHit" style="font-weight: bold;">HIT</span>
          <span *ngIf="!report.NIBINHit">POTENTIAL</span>
        </span>
        </ng-template>


        <ng-template #rowActions let-report>
        <span>
          <button mat-icon-button *ngIf="(report.Lab?.toLowerCase() == user.CurrentDept.toLowerCase()) && report.ReportStatus!='COMPLETE' && report.ReportStatus !=='RESEND EMAIL'" matTooltip="Delete Pending Report" (click)="DeletePendingReport(report)">
            <mat-icon>delete</mat-icon>
          </button>

          <button mat-icon-button (click)="EmailReport(report)" [disabled]="!isReportAssociationsCompleted(report) || report.Incidents?.length<2" *ngIf="(report.Lab?.toLowerCase() == user.CurrentDept.toLowerCase()) && report.ReportStatus ==='RESEND EMAIL'" matTooltip="Send Email"><mat-icon>send</mat-icon></button>

          <button mat-icon-button *ngIf="(report.Lab?.toLowerCase() == user.CurrentDept.toLowerCase()) && report.ReportStatus=='COMPLETE'" matTooltip="Rescind Completed Report" (click)="RescindReport(report)">
            <mat-icon>cancel_schedule_send</mat-icon>
          </button>
        </span>
        </ng-template>

        <ng-template #EnteredDateTimeTPL let-report>
          {{report.EnteredDateTime | date:'MM-dd-yyyy'}}
        </ng-template>

        <ng-template #EmailSentTPL let-report>
          {{report.EmailSent | date:'MM-dd-yyyy'}}
        </ng-template>

        <ejs-grid
          #ListGrid
          style="margin-top: 10px;"
          [dataSource]='dataSource2'
          [allowPaging]="true"
          [allowSorting]="true"
          [allowFiltering]="true"
          [detailTemplate]="detailRow"
          [filterSettings]="{type: 'Excel'}"
          [allowTextWrap]="true"
          [textWrapSettings]="{ wrapMode: 'Both' }"
          [pageSettings]="{pageSize:25}"
        >
          <e-columns>
            <e-column field='Lab' headerText='Lab' textAlign='Left'></e-column>
            <e-column [template]="NIBINHitTemplate" field='NIBINHit' headerText='Hit Type' textAlign='Left' [allowFiltering]="false"></e-column>
            <e-column field='ReferenceNumber' headerText=' Reference/HIT #' textAlign='Left'></e-column>
            <e-column field='Examiner' headerText='Examiner' textAlign='Left'></e-column>
            <!-- <e-column template="" headerText='Lab # ' textAlign='Left'></e-column>
             <e-column template="" headerText=' Incident Type' textAlign='Left'></e-column>
             <e-column template="" headerText=' # of Incidents' textAlign='Left'></e-column>-->
            <e-column [template]="EmailSentTPL" field='EmailSent' headerText='Date of Complete' textAlign='Left'></e-column>
            <e-column [template]="EnteredDateTimeTPL" field='EnteredDateTime' headerText='Date of Entry' textAlign='Left'></e-column>
            <e-column field='ReportStatus' headerText='Status' textAlign='Left'></e-column>
            <e-column [template]="rowActions" headerText='Actions' textAlign='Left'></e-column>
          </e-columns>

          <!--<ng-template #pagerTemplate let-data>

          </ng-template>-->

        </ejs-grid>
      </div>

      <div>
        <app-report-modify-form [Incidents]="incidentsImport" (DoneEvent)="modifyFormIsComplete($event)"></app-report-modify-form>
      </div>
      <div>
        <app-report-modify-form [Incidents]="incidentsEdit" [ReportInfo]="reportInfoEdit" [CType]="1" (DoneEvent)="modifyFormIsComplete($event)"></app-report-modify-form>
      </div>
    </div>
  </ejs-tab>

</mat-card>

